import { AlarmSeverity, AlarmType } from '../../pages/sensors-v2/types/sensors';

export const SEVERITY_BY_ALARM_TYPE: Record<AlarmType, AlarmSeverity> = {
  door: 'high', bolt: 'high', door_lock: 'high', violation: 'high', request_opening_of_safe: 'high',
  vibration: 'medium', energy: 'medium', sound: 'medium',
  maximum_time_for_open_door: 'medium', cable_cut_alarm: 'medium',
};

export const ALARM_LABEL: Record<AlarmType, string> = {
  door: 'Porta', bolt: 'Ferrolho', door_lock: 'Trava',
  vibration: 'Vibração', energy: 'Energia', sound: 'Som',
  violation: 'Violação', request_opening_of_safe: 'Abertura',
  maximum_time_for_open_door: 'Tempo Porta', cable_cut_alarm: 'Cabo',
};

export function severityColor(s: AlarmSeverity): { bg: string; text: string; bar: string } {
  switch (s) {
    case 'high': return { bg: '#fee2e2', text: '#dc2626', bar: '#dc2626' };
    case 'medium': return { bg: '#fef3c7', text: '#d97706', bar: '#d97706' };
    case 'low': return { bg: '#dcfce7', text: '#16a34a', bar: '#16a34a' };
  }
}

export function maxSeverity(alarms: { severity: AlarmSeverity }[]): AlarmSeverity {
  if (alarms.some((a) => a.severity === 'high')) return 'high';
  if (alarms.some((a) => a.severity === 'medium')) return 'medium';
  return 'low';
}

export function timeAgo(iso: string | null): string {
  if (!iso) return '';
  const diff = Date.now() - new Date(iso).getTime();
  if (diff < 60_000) return 'agora';
  if (diff < 3_600_000) return `${Math.floor(diff / 60_000)}min`;
  if (diff < 86_400_000) return `${Math.floor(diff / 3_600_000)}h`;
  return `${Math.floor(diff / 86_400_000)}d`;
}
